import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function HalfThousandIllustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3986" data-mp="2jb8j6kobn5rp">
      
      <div className="relative w-full h-full bg-gradient-to-b from-indigo-300 via-violet-400 to-purple-500 overflow-hidden" data-id="element-3987" data-mp="2edyl6gmv9ls9">
        {/* Background: Launch sky + stars */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3988" data-mp="24f93ooyvu3cj">
          
          <circle cx="40" cy="40" r="2" fill="white" data-id="element-3989" data-mp="20f8rlaz9a48n" />
          <circle cx="160" cy="30" r="1.5" fill="white" data-id="element-3990" data-mp="2ltdtuamcsim" />
          <circle cx="120" cy="60" r="2" fill="white" data-id="element-3991" data-mp="3ur6nyccgv5n4" />
          <circle cx="30" cy="90" r="1.5" fill="white" data-id="element-3992" data-mp="3urf54gfmgx44" />
          <circle cx="175" cy="80" r="2" fill="white" data-id="element-3993" data-mp="2lpird7rd4eny" />
          {/* Rocket trail */}
          <path d="M100 200 Q95 150 100 110 Q105 150 100 200 Z" fill="#FCD34D" opacity="0.5" data-id="element-3994" data-mp="2qovfdvtyzrs4" />
          
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[6%]" data-id="element-3995" data-mp="2cqoxhp5f22e3">
          <div className="w-[64%] h-[64%] flex items-center justify-center" data-id="element-3996" data-mp="2gs0fb8i1tjbq">
            <DjaySpecimen look={{
            variant,
            accessory: 'starWand'
          }} size="hero" emotion={isUnlocked ? 'celebrating' : 'sleeping'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3997" data-mp="34g1lwbvo2poi" />
            
          </div>
        </div>

        {/* Foreground: "500" + sparks */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3998" data-mp="2zoih6iqm2zlp">
          
            <text x="100" y="44" textAnchor="middle" fontFamily="sans-serif" fontSize="24" fontWeight="900" fill="#FDE047" stroke="#7C3AED" strokeWidth="1" data-id="element-3999" data-mp="3s5vxyr85wa7p">
            
              500
            </text>
            <path d="M40 120 L42 128 L50 130 L42 132 L40 140 L38 132 L30 130 L38 128 Z" fill="#FDE047" data-id="element-4000" data-mp="1ulpd820hocn" />
          
            <path d="M165 130 L167 137 L174 139 L167 141 L165 148 L163 141 L156 139 L163 137 Z" fill="#A78BFA" data-id="element-4001" data-mp="3t0dbzxgkyiup" />
          
          </svg>}
      </div>
    </DjayIllustrationBase>;
}